import script from "./FileLibraryForm.vue?vue&type=script&lang=ts&setup=true"
export * from "./FileLibraryForm.vue?vue&type=script&lang=ts&setup=true"

import "./FileLibraryForm.vue?vue&type=style&index=0&id=67865303&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-67865303"]])

export default __exports__